/**
* @name: left-layout-div
* @author: weiyong
* @date: 2023-05-11 18:01
* @description：left-layout-div
* @update: 2023-05-11 18:01
*/
<template>
  <div :class="[prefixCls,openFlag?'is-opened':'is-not-opened',getMenuTheme,getMenuExtendTheme]" class="side-menu h100b" :style="'--el-custom-sidebar-bg-color:'+getMenuBgColor">
     <ul class="el-custom-sidebar  el-custom--sidebar-vertical h100b"
         :class="openFlag?'el-custom-not-sidebar--collapse':'el-custom-sidebar--collapse'">
<!--       缩小菜单-->
        <collapse-menu :openFlag="openFlag"/>
     </ul>

    <i class="el-icon el-custom-sidebar__icon-arrow collapse-button "
       @click="openClick" :class="openFlag?'is-opened':'is-not-opened'">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" v-if="openFlag">
        <path fill="currentColor" d="M609.408 149.376 277.76 489.6a32 32 0 0 0 0 44.672l331.648 340.352a29.12 29.12 0 0 0 41.728 0 30.592 30.592 0 0 0 0-42.752L339.264 511.936l311.872-319.872a30.592 30.592 0 0 0 0-42.688 29.12 29.12 0 0 0-41.728 0z"></path>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" v-if="!openFlag" viewBox="0 0 1024 1024"><path fill="currentColor" d="M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z"></path>
      </svg>
    </i>
  </div>

</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "left-layout-div",
});
</script>

<script lang="ts" setup>
import CollapseMenu from "./collapse-menu.vue";
import {useDesign} from "@/hooks/web/useDesign";
import {GoingNewUtils, StorageUtils} from 'xmgoing-utils';
import GoingUtils from "@/utils/goingUtils";
import {useMenuSetting} from "@/hooks/setting/useMenuSetting";

const {prefixCls} = useDesign('left-layout-div');

const openFlag=ref(GoingNewUtils.parseBoolean(StorageUtils.getItem("openFlag")+""));
const openClick=()=>{
  openFlag.value=!openFlag.value;
  StorageUtils.addItem("openFlag",unref(openFlag));
}


const {
  getMenuExtendTheme,
  getMenuBgColor,
  getMenuTheme,
  getCollapsed,
  getSplit,
} = useMenuSetting();
</script>

<style type="text/css" lang="less" scoped>
@prefix-cls: ~'@{namespace}-left-layout-div';

.@{prefix-cls} {
  &.side-menu{
    z-index: 101;
    position: sticky;
    background-color: var(--primary-color,#065979);
    .el-custom--sidebar-vertical{

    }
  }

  &.is-opened{
    .collapse-button{
      left: calc(205px - 8px);
    }
  }
  .el-custom-sidebar{
    list-style: none;
    position: relative;
    padding-left: 0;
    background: var(--el-custom-sidebar-bg-color);
    box-sizing: border-box;
    display: flex;
    gap: 8px;
    flex-direction: column;
    transition: all .3s;
  }
  .el-custom-sidebar--collapse{
    width:80px;
  }

  .el-custom--sidebar-vertical:not(.el-custom-sidebar--collapse) {
    width: 205px;
  }

  .collapse-button {
    top: 64px;
    width: 18px;
    height: 18px;
    color: #5e5e5e;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-radius: 100%;
    position: absolute;
    left: 90%;
    cursor:pointer;
    &.el-icon svg {
      height: 0.8em;
      width: 0.8em;
    }
  }
}

</style>
